import { render, staticRenderFns } from "./SfButton.vue?vue&type=template&id=3267e628&functional=true"
import script from "./SfButton.vue?vue&type=script&lang=js"
export * from "./SfButton.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfButton.vue?vue&type=style&index=0&id=3267e628&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  "62a65d32"
  
)

export default component.exports